export const PICK_UP_ADDRESS_AVAILABLE = "available";

type Inputs = {
    optionInputElements: NodeListOf<HTMLInputElement>;
    addressInputsElement: HTMLElement;
    noteElement: HTMLElement;
}

function updateVisibility({ optionInputElements, addressInputsElement, noteElement }: Inputs) {
    const selected = Array.from(optionInputElements).find((input) => input.checked);
    const hasAddress = selected?.value === PICK_UP_ADDRESS_AVAILABLE;
    addressInputsElement.style.display = hasAddress ? "block" : "none";
    noteElement.style.display = hasAddress ? "none" : "block";
}

export function togglePickUpAddressInputs(inputs: Inputs) {
    inputs.optionInputElements.forEach((input) => {
        input.addEventListener("change", () => updateVisibility(inputs));
    });
    updateVisibility(inputs);
}
